import { api } from './api';

export type AllocationBasis = 'equal' | 'headcount' | 'by-account' | 'manual';

export interface AllocationRule {
  id: string;
  workspace_id: string;
  name: string;
  basis: AllocationBasis;
  pool_account: string;
  target_dimension_key: string;
  allocation_account: string | null;
  period_start: string;
  period_end: string;
  scenario: string;
  config: { accountKey?: string; weights?: Record<string, number> };
  enabled: boolean;
}

export interface AllocationPreview {
  ruleId: string;
  currencies: Array<{
    currency: string;
    poolTotal: number;
    perMember: Array<{ member: string; weight: number; share: number }>;
  }>;
}

export interface AllocationInput {
  name: string;
  basis: AllocationBasis;
  poolAccount: string;
  targetDimensionKey: string;
  allocationAccount?: string | null;
  periodStart: string;
  periodEnd: string;
  scenario: string;
  config?: { accountKey?: string; weights?: Record<string, number> };
  enabled?: boolean;
}

export const allocationsApi = {
  async list(wsId: string): Promise<AllocationRule[]> {
    return (await api.get<AllocationRule[]>(`/api/workspaces/${wsId}/allocations`)).data;
  },
  async create(wsId: string, body: AllocationInput): Promise<AllocationRule> {
    return (await api.post<AllocationRule>(`/api/workspaces/${wsId}/allocations`, body)).data;
  },
  async update(wsId: string, id: string, patch: Partial<AllocationInput>): Promise<AllocationRule> {
    return (await api.patch<AllocationRule>(`/api/workspaces/${wsId}/allocations/${id}`, patch)).data;
  },
  async remove(wsId: string, id: string): Promise<void> {
    await api.delete(`/api/workspaces/${wsId}/allocations/${id}`);
  },
  async preview(wsId: string, id: string): Promise<AllocationPreview> {
    return (await api.get<AllocationPreview>(`/api/workspaces/${wsId}/allocations/${id}/preview`)).data;
  },
  async run(wsId: string, id: string): Promise<{ ruleId: string; factsInserted: number; preview: AllocationPreview }> {
    return (await api.post<{ ruleId: string; factsInserted: number; preview: AllocationPreview }>(`/api/workspaces/${wsId}/allocations/${id}/run`, {})).data;
  },
};
